import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    downloadTitle: string;
    downloadDetails: string;
    downloadAppReq: string;
    downloadInDriveApp: string;
    downloadInTransferApp: string;
    downloadInBrowser: string;
    cancelDownload: string;
    rememberDownloadPreference: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            downloadTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DownloadModal.downloadTitle?c=3c67ppjbc6w5g", defaultMessage: "Download with the Desktop App" }));
                },
                enumerable: true,
                configurable: true
            },
            downloadDetails: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DownloadModal.downloadDetails?c=3ggo083gv7gr3", defaultMessage: "Unlock even faster download speeds, plus preserve your folder structures on download." }));
                },
                enumerable: true,
                configurable: true
            },
            downloadAppReq: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DownloadModal.downloadAppReq?c=5d4qle354b64", defaultMessage: "Requires version 1.2.0 or later" }));
                },
                enumerable: true,
                configurable: true
            },
            downloadInDriveApp: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DownloadModal.downloadInDriveApp?c=3fx939qcapbri", defaultMessage: "Download with Frame.io Drive" }));
                },
                enumerable: true,
                configurable: true
            },
            downloadInTransferApp: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DownloadModal.downloadInTransferApp?c=1yx2aub5tsvec", defaultMessage: "Download with Frame.io Transfer" }));
                },
                enumerable: true,
                configurable: true
            },
            downloadInBrowser: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DownloadModal.downloadInBrowser?c=46g0wynhfftz", defaultMessage: "Download in Browser" }));
                },
                enumerable: true,
                configurable: true
            },
            cancelDownload: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DownloadModal.cancelDownload?c=3ntvs5qfav2i3", defaultMessage: "Cancel download" }));
                },
                enumerable: true,
                configurable: true
            },
            rememberDownloadPreference: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DownloadModal.rememberDownloadPreference?c=2z7lwr4ubeb5x", defaultMessage: "Always use this download method" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
